import { NeedModel } from "@/Domains";
import { AppEnum } from "../Types";
import { AppEnumHelper } from "./app-enum.helper";
import { dateCompare } from "./util.helper";


/**
 * =====================================================
 * SortModelHelper
 * =====================================================
 *
 * Central helper class for static sorting functions
 * across different domain models.
 * 
 * Currently, only sortNeed is implemented. Additional
 * static methods (e.g., sortContact, sortProperty) can
 * be added here as needed.
 *
 * This class is not intended to be extended.
 *
 * Author: Samano CASTRE
 * Date: February 1, 2026
 */
export class SortModelHelper {


    /**
     * =====================================================
     * sortNeed
     * =====================================================
     *
     * Sorts two NeedModel objects for display in lists/tables.
     *
     * Sorting rules:
     * 1. Needs with status "INPROGRESS" appear first
     * 2. If both are in the same progress state, sort by creation date ascending
     *
     * @param NeedStatusEnum - Enum array representing all possible Need statuses
     * @param a - first NeedModel
     * @param b - second NeedModel
     * @returns number suitable for Array.sort
     */
    static sortNeed(NeedStatusEnum: AppEnum[], a : NeedModel, b : NeedModel): number {
        
        // Map each Need's status to its corresponding enum
        const aEnum = AppEnumHelper.getByValue(
            NeedStatusEnum,
            a.status
        );
        const bEnum = AppEnumHelper.getByValue(
            NeedStatusEnum,
            b.status
        );

        // Check if either need is in progress
        const aIsInProgress = aEnum?.key === 'INPROGRESS';
        const bIsInProgress = bEnum?.key === 'INPROGRESS';

        // Prioritize INPROGRESS needs
        if (aIsInProgress !== bIsInProgress) {
            return aIsInProgress ? -1 : 1;
        }

        // If status priority is equal, sort by creation date
        return dateCompare(a.createdAt ?? "", b.createdAt ?? "");
    }



    // =====================================================
    // Additional static sorting methods for other domain models
    // can be implemented here following the same pattern.
}